// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-background {
	position: absolute;
	inset: 0rem;
	background-color: rgba(255, 255, 255, 0.8);
	z-index: 6001;
}
.CookieConsent {
	flex-direction: column;
	flex-wrap: unset !important;
	align-items: flex-end !important;
	justify-items: unset !important;
	justify-content: unset !important;
	flex-basis: content !important;
	background-color: rgba(255, 255, 255, 0.9) !important;
	color: var(--primary-color1) !important;
	border-radius: 0.5rem !important;
	box-shadow: 1px 1px 3px 1px rgb(60, 60, 60) !important;
	z-index: 10001 !important;
}
.CookieConsent div {
	flex: unset !important;
	background-color: transparent !important;
	color: var(--primary-color1) !important;
	z-index: 5001;
}

#iubenda-pp {
	z-index: 20000 !important;
}

.modal-content {
	display: flex;
	flex-direction: column;
	bottom: 0;
	padding: 1rem;
	color: white;
	z-index: 6002;
	align-content: center;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
.modal-content p {
	font-size: 1.4rem;
	text-align: justify;
	line-height: 2.5rem;
}
.modal-content h1 {
	font-size: 2rem;
	text-align: center;
}
.modal-content a {
	font-size: 1.4rem;
	margin: 0rem 1rem;
}
.modal-button {
	display: flex;
	background-color: rgb(75, 74, 74);
	border-radius: 0.5rem;
	align-self: flex-end;
	box-shadow: 1px 1px 3px 1px rgb(60, 60, 60);
	height: 3rem;
	width: 7rem;
	align-items: center;
	justify-content: center;
}

.modal-button:hover {
	background-color: var(--primary-color2);
}
.modal-button p {
	color: white;
}
.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal {
	padding-left: 20px !important;
	margin: 0rem 0.2rem !important;
}
.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal:hover {
	box-shadow: 1px 1px 3px 1px black;
	padding-left: 20px !important;
	margin: 0rem 0.2rem !important;
}
@media (min-width: 500px) {
	.modal-content {
		display: flex;
		flex-direction: column;
		/* position: absolute; */
		bottom: 0;
		padding: 1vw;
		/* background-color: rgba(55, 53, 53, 0.73);*/
		color: white;
		z-index: 6002;
		align-content: center;
		align-items: center;
		justify-content: space-between;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/cookieConsent/Modal/modal.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,0CAA0C;CAC1C,aAAa;AACd;AACA;CACC,sBAAsB;CACtB,2BAA2B;CAC3B,gCAAgC;CAChC,+BAA+B;CAC/B,iCAAiC;CACjC,8BAA8B;CAC9B,qDAAqD;CACrD,uCAAuC;CACvC,gCAAgC;CAChC,sDAAsD;CACtD,yBAAyB;AAC1B;AACA;CACC,sBAAsB;CACtB,wCAAwC;CACxC,uCAAuC;CACvC,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;CACb,YAAY;CACZ,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,8BAA8B;CAC9B,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iCAAiC;CACjC,qBAAqB;CACrB,oBAAoB;CACpB,2CAA2C;CAC3C,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,YAAY;AACb;AACA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;CACC,iCAAiC;CACjC,6BAA6B;CAC7B,8BAA8B;AAC/B;AACA;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;EACT,YAAY;EACZ,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;CAC/B;AACD","sourcesContent":[".modal-background {\n\tposition: absolute;\n\tinset: 0rem;\n\tbackground-color: rgba(255, 255, 255, 0.8);\n\tz-index: 6001;\n}\n.CookieConsent {\n\tflex-direction: column;\n\tflex-wrap: unset !important;\n\talign-items: flex-end !important;\n\tjustify-items: unset !important;\n\tjustify-content: unset !important;\n\tflex-basis: content !important;\n\tbackground-color: rgba(255, 255, 255, 0.9) !important;\n\tcolor: var(--primary-color1) !important;\n\tborder-radius: 0.5rem !important;\n\tbox-shadow: 1px 1px 3px 1px rgb(60, 60, 60) !important;\n\tz-index: 10001 !important;\n}\n.CookieConsent div {\n\tflex: unset !important;\n\tbackground-color: transparent !important;\n\tcolor: var(--primary-color1) !important;\n\tz-index: 5001;\n}\n\n#iubenda-pp {\n\tz-index: 20000 !important;\n}\n\n.modal-content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbottom: 0;\n\tpadding: 1rem;\n\tcolor: white;\n\tz-index: 6002;\n\talign-content: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n.modal-content p {\n\tfont-size: 1.4rem;\n\ttext-align: justify;\n\tline-height: 2.5rem;\n}\n.modal-content h1 {\n\tfont-size: 2rem;\n\ttext-align: center;\n}\n.modal-content a {\n\tfont-size: 1.4rem;\n\tmargin: 0rem 1rem;\n}\n.modal-button {\n\tdisplay: flex;\n\tbackground-color: rgb(75, 74, 74);\n\tborder-radius: 0.5rem;\n\talign-self: flex-end;\n\tbox-shadow: 1px 1px 3px 1px rgb(60, 60, 60);\n\theight: 3rem;\n\twidth: 7rem;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.modal-button:hover {\n\tbackground-color: var(--primary-color2);\n}\n.modal-button p {\n\tcolor: white;\n}\n.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal {\n\tpadding-left: 20px !important;\n\tmargin: 0rem 0.2rem !important;\n}\n.iubenda-embed:not(.no-brand):not(.iubenda-nostyle).internal:hover {\n\tbox-shadow: 1px 1px 3px 1px black;\n\tpadding-left: 20px !important;\n\tmargin: 0rem 0.2rem !important;\n}\n@media (min-width: 500px) {\n\t.modal-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\t/* position: absolute; */\n\t\tbottom: 0;\n\t\tpadding: 1vw;\n\t\t/* background-color: rgba(55, 53, 53, 0.73);*/\n\t\tcolor: white;\n\t\tz-index: 6002;\n\t\talign-content: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
